import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { clientiApi, interventiApi } from '../services/api';

export default function NuovoIntervento() {
  const navigate    = useNavigate();
  const [clienti, setClienti]   = useState([]);
  const [cercaC, setCercaC]     = useState('');
  const [clienteSel, setClSel]  = useState(null);
  const [form, setForm]         = useState({
    data_intervento: new Date().toISOString().split('T')[0],
    ora_inizio: '',
    ora_fine:   '',
    note: '',
  });
  const [tecnici, setTecnici] = useState([]);
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState('');

  useEffect(() => {
    clientiApi.getAll()
      .then(r => setClienti(r.data?.data || []))
      .catch(console.error);
  }, []);

  const clientiFiltrati = clienti.filter(c => {
    if (!cercaC) return true;
    const parole = cercaC.toLowerCase().split(' ').filter(Boolean);
    const campi  = [c.nome, c.indirizzo, c.citta, c.zona, c.cap].filter(Boolean).join(' ').toLowerCase();
    return parole.every(p => campi.includes(p));
  });

  useEffect(() => {
    api.get('/interventi/tecnici')
      .then(r => setTecnici(r.data?.data || []))
      .catch(() => {});
  }, []);

  const salva = async () => {
    if (!clienteSel) { setError('Seleziona un cliente.'); return; }
    setSaving(true); setError('');
    try {
      const res = await interventiApi.create({
        clienteId:       clienteSel.id,
        sitoNome:        clienteSel.nome,
        indirizzo:       clienteSel.indirizzo,
        dataIntervento:  form.data_intervento,
        oraInizio:       form.ora_inizio || null,
        oraFine:         form.ora_fine   || null,
        note:            form.note,
        tecnicoId:       form.tecnico_id ? Number(form.tecnico_id) : null,
      });
      const id = res.data?.data?.id || res.data?.id;
      navigate(`/interventi/${id}`);
    } catch(e) {
      setError(e.response?.data?.error || 'Errore nel salvataggio.');
    } finally { setSaving(false); }
  };

  return (
    <div className="page-content">
      <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:16}}>
        <button className="btn btn-secondary" onClick={()=>navigate('/interventi')}>⬅ Indietro</button>
        <h2 style={{margin:0}}>➕ Nuovo intervento</h2>
      </div>

      {error && <div className="error-msg" style={{marginBottom:16}}>{error}</div>}

      <div style={{maxWidth:600}}>

        {/* CLIENTE */}
        <div className="card" style={{marginBottom:16}}>
          <div className="card-title" style={{marginBottom:12}}>👥 Cliente</div>
          {clienteSel ? (
            <div style={{display:'flex',alignItems:'center',gap:12}}>
              <div style={{flex:1}}>
                <strong>{clienteSel.nome}</strong>
                {clienteSel.indirizzo && <div style={{fontSize:12,color:'#6b7280'}}>{clienteSel.indirizzo}</div>}
                {clienteSel.zona && <span className="badge badge-gray" style={{fontSize:11}}>{clienteSel.zona}</span>}
              </div>
              <button className="btn btn-secondary btn-sm"
                onClick={()=>{setClSel(null);setCercaC('');}}>✕ Cambia</button>
            </div>
          ) : (
            <div>
              <input className="form-control"
                placeholder="Cerca per nome, via, zona... (es: autorimessa arco)"
                value={cercaC} onChange={e=>setCercaC(e.target.value)}
                style={{marginBottom:8}} autoFocus />
              {cercaC && (
                <div style={{border:'1px solid #e5e7eb',borderRadius:6,maxHeight:250,overflowY:'auto',background:'#fff'}}>
                  {clientiFiltrati.slice(0,20).map(c=>(
                    <div key={c.id}
                      onClick={()=>{setClSel(c);setCercaC(c.nome);}}
                      style={{padding:'10px 12px',cursor:'pointer',borderBottom:'1px solid #f3f4f6'}}
                      onMouseEnter={e=>e.currentTarget.style.background='#f9fafb'}
                      onMouseLeave={e=>e.currentTarget.style.background=''}>
                      <div style={{fontWeight:600,fontSize:13}}>{c.nome}</div>
                      <div style={{fontSize:12,color:'#9ca3af'}}>{c.indirizzo||''} {c.citta||''}</div>
                    </div>
                  ))}
                  {clientiFiltrati.length===0 && <div style={{padding:12,color:'#9ca3af',fontSize:13}}>Nessun cliente trovato</div>}
                </div>
              )}
            </div>
          )}
        </div>

        {/* DATA E NOTE */}
        <div className="card" style={{marginBottom:16}}>
          <div className="card-title" style={{marginBottom:12}}>📋 Dettagli</div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:12}}>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Data intervento</label>
              <input type="date" className="form-control" value={form.data_intervento}
                onChange={e=>setForm(f=>({...f,data_intervento:e.target.value}))} />
            </div>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Ora inizio</label>
              <input type="time" className="form-control" value={form.ora_inizio}
                onChange={e=>setForm(f=>({...f,ora_inizio:e.target.value}))} />
            </div>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Ora fine</label>
              <input type="time" className="form-control" value={form.ora_fine}
                onChange={e=>setForm(f=>({...f,ora_fine:e.target.value}))} />
            </div>
          </div>
          <div className="form-group" style={{margin:0}}>
            <label className="form-label">Tecnico assegnato</label>
            <select className="form-control" value={form.tecnico_id || ''}
              onChange={e=>setForm(f=>({...f, tecnico_id: e.target.value}))}>
              <option value="">— non assegnato —</option>
              {tecnici.map(t => <option key={t.id} value={t.id}>{t.nome || t.username}</option>)}
            </select>
          </div>

          <div className="form-group" style={{margin:0}}>
            <label className="form-label">Note</label>
            <textarea className="form-control" rows={3} value={form.note}
              onChange={e=>setForm(f=>({...f,note:e.target.value}))}
              placeholder="Note sull'intervento..." />
          </div>
        </div>

        <div style={{display:'flex',gap:8}}>
          <button className="btn btn-primary" onClick={salva} disabled={saving}>
            {saving?'Creazione...':'✅ Crea intervento'}
          </button>
          <button className="btn btn-secondary" onClick={()=>navigate('/interventi')}>Annulla</button>
        </div>
      </div>
    </div>
  );
}
